import * as _ from "lodash";
import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "dataFilterFormControlIgnoreCase"
})

export class DataFilterFormControlIgnoreCasePipe implements PipeTransform { 
    transform(array: any[], query: string, name?: string): any {
        
        if (query) {
            if (name) {
                return _.filter(array, row => {
                    return row.value[name].toUpperCase().indexOf(query.toUpperCase()) > -1});
            }
            return _.filter(array, row => {
                return row.value.name.toUpperCase().indexOf(query.toUpperCase()) > -1});
        }
        return array;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/data-filter-form-controli-ignore-case.pipe.ts